import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import { ReactNode } from 'react';
import Icon from '../display/Icon';
import classes from './NoItemsBox.module.scss';

export default function NoItemsBox({
  children,
  className,
  itemsName = 'items',
  ...rest
}: {
  itemsName?: ReactNode;
} & BoxProps) {
  return (
    <Box className={clsx(classes.root, className)} {...rest}>
      <Icon icon="creative-commons-zero" size="large" />
      <div className={classes.children}>
        {children || `No ${itemsName} yet`}
      </div>
    </Box>
  );
}

NoItemsBox.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  mt: 3,
};
